import { errorHandle } from 'redux/actions/error';
import apiService from 'shared/services/ApiService';
import {
  SET_TRX_GOLD_LIST,
  PROCESSING,
  UPDATE_GOLD_STATUS,
  SET_ACCOUNT_DETAIL,
  GET_ACCOUNT_TRANSACTION,
  SET_ACCOUNT_TRANSACTION,
} from './types';
const { aurumApiService } = apiService.getInstance();

export const setListTransactions = (data, filter) => ({
  type: SET_TRX_GOLD_LIST,
  payload: data,
  filter,
});

export const setProcessing = () => ({
  type: PROCESSING,
});

export const getListTransactions = (
  paginationUrl,
  paramUrl = '',
) => dispatch => {
  dispatch(transactions.setProcessing());

  const orderUrl = `orders?${paginationUrl}${paramUrl}`;

  aurumApiService
    .get(orderUrl)
    .then(transactions.onGetListTransactionsSuccess(dispatch))
    .catch(transactions.onGetListTransactionsError(dispatch));
};

export const onGetListTransactionsSuccess = dispatch => response => {
  if (response.status === 200) {
    const { payload, pagination } = response.data;
    dispatch(transactions.setListTransactions(payload, pagination));
  }
};

export const onGetListTransactionsError = dispatch => error => {
  errorHandle(error);
  dispatch(transactions.setListTransactions([]));
};

export const updateStatus = (id, status) => async dispatch => {
  dispatch(transactions.setProcessing());
  const orderUrl = `orders/${id}`;
  let resolve = 'error';
  try {
    const result = await aurumApiService.patch(orderUrl, { status });
    if (result.status === 204) {
      resolve = 'success';
    }
  } catch (err) {
    resolve = 'error';
  }
  dispatch({ type: UPDATE_GOLD_STATUS });
  return resolve;
};

export const manualDisburse = id => async dispatch => {
  dispatch(transactions.setProcessing());
  const disburseUrl = 'orders/disbursement';
  let resolve = 'error';
  try {
    const params = {
      sales_order_id: id,
    };
    const result = await aurumApiService.post(disburseUrl, {
      ...params,
    });
    if ([200, 204].includes(result.status)) {
      resolve = 'success';
    }
  } catch (err) {
    resolve = 'error';
  }
  dispatch({ type: UPDATE_GOLD_STATUS });
  return resolve;
};

export const getAccountDetail = id => dispatch => {
  dispatch(transactions.setProcessing());

  aurumApiService
    .get(`accounts/dana/${id}`)
    .then(transactions.onGetAccountDetailSuccess(dispatch))
    .catch(transactions.onGetAccountDetailError(dispatch));
};

export const onGetAccountDetailSuccess = dispatch => response => {
  if (response.status === 200) {
    const { payload } = response.data;
    dispatch({ type: SET_ACCOUNT_DETAIL, payload });
  }
};

export const onGetAccountDetailError = dispatch => error => {
  errorHandle(error);
  dispatch({ type: SET_ACCOUNT_DETAIL, payload: {} });
};

export const getAccountTrx = (paginationUrl, paramUrl = '') => dispatch => {
  dispatch({ type: GET_ACCOUNT_TRANSACTION });

  aurumApiService
    .get(`orders/history?${paginationUrl}${paramUrl}`)
    .then(transactions.onGetAccountTrxSuccess(dispatch))
    .catch(transactions.onGetAccountTrxError(dispatch));
};

export const onGetAccountTrxSuccess = dispatch => response => {
  if (response.status === 200) {
    const { payload, pagination } = response.data;
    dispatch({ type: SET_ACCOUNT_TRANSACTION, payload, filter: pagination });
  }
};

export const onGetAccountTrxError = dispatch => error => {
  errorHandle(error);
  dispatch({ type: SET_ACCOUNT_TRANSACTION, payload: {} });
};

const transactions = {
  setListTransactions,
  getListTransactions,
  onGetListTransactionsSuccess,
  onGetListTransactionsError,
  setProcessing,
  getAccountTrx,
  onGetAccountDetailSuccess,
  onGetAccountDetailError,
  onGetAccountTrxSuccess,
  onGetAccountTrxError,
};

export default transactions;
